<template>
  <div id="app" ref="main">
    <headertitle></headertitle>
    <Transition name="fade" mode="out-in">
      <router-view />
    </Transition>
    <Footw></Footw>
  </div>
</template>
<script>
import headertitle from "./views/project/headertitle.vue";
import Footw from "./views/project/foot.vue";
import DevicePixelRatio from '@/utils/DevicePixelRatio.js';
export default {
  components: { headertitle, Footw },
  data() {
    return {
      onLine: navigator.onLine,
    };
  },
  mounted() {
    if (window.location.pathname == "/Home") {
      if (this._isMobile()) {
        // this.$router.replace("/mHome");
        this.$router.replace("/Home");
      } else {
        this.$router.replace("/Home");
      }
    }
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.bodyScale()
  },
  methods: {
     bodyScale () {
      var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
      var scale = devicewidth / 1920; // 分母——设计稿的尺寸
      document.body.style.zoom = scale;//放大缩小相应倍数
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
      if (navigator.onLine) {
        location.reload();
      } else {
        //执行离线状态时的任务
        this.$message.warning("没网了哦");
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 900px) {
  .el-message--warning .el-message__content {
    font-size: 30px;
    line-height: 0.2;
  }
}

.el-message {
  font-size: 30px;
  line-height: 1.2;
}

/* body {
  overflow-y: auto !important;
  padding-right: 0 !important;
} */
</style>
